import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FlipperContainer = styled.div`
  padding: ${Spacing.S8} 0px;

  svg {
    cursor: pointer;
  }
`
